import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row, Select, Skeleton, theme } from 'antd';
import { PosFormItem } from 'pos-client/components/shared/Form/PosFormItem.tsx';
import type { LocationLinkedAssetWithFullNameModel } from 'pos-client/hooks/useLocationAssignedAssets.tsx';
import type { LocationLinkedAssetModel } from 'pos-shared/models/locationSchema.ts';
import type { RMAssetFormType } from 'pos-shared/models/resourceManagementSchema.ts';
import { ServiceTypesRequestSchema } from 'pos-shared/models/schedulingSchema.ts';

type SetupTabProps = {
  form: UseFormReturn<RMAssetFormType>;
  technicians: LocationLinkedAssetWithFullNameModel[];
  vans: LocationLinkedAssetModel[];
  serviceTypeFilter: string;
};

export const SetupTabContentSkeleton = () => {
  const { token } = theme.useToken();

  return (
    <Row gutter={token.margin}>
      <Col span={12}>
        <Skeleton.Input active block />
      </Col>
      <Col span={12}>
        <Skeleton.Input active block />
      </Col>
    </Row>
  );
};

export const SetupTabContent = ({
  form,
  technicians,
  vans,
  serviceTypeFilter,
}: SetupTabProps) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const { control, getValues } = form;
  const values = getValues();

  return (
    <Row gutter={token.margin}>
      {serviceTypeFilter === ServiceTypesRequestSchema.enum.Mobile && (
        <>
          <Col span={12}>
            <PosFormItem
              label={t('assets.asset')}
              name="asset"
              control={control}
            >
              <Select
                defaultValue={values.asset}
                options={vans}
                fieldNames={{
                  label: 'name',
                  value: 'id',
                }}
                optionFilterProp="name"
                showSearch
              />
            </PosFormItem>
          </Col>
        </>
      )}
      <Col span={12}>
        <PosFormItem
          label={t('technicians.technician')}
          name="technician"
          control={control}
        >
          <Select
            defaultValue={values.technician}
            options={technicians}
            fieldNames={{
              label: 'fullName',
              value: 'id',
            }}
            optionFilterProp="fullName"
            showSearch
          />
        </PosFormItem>
      </Col>
    </Row>
  );
};
